import React from 'react'

const Election = () => {
  return (
    <div>
    <h1>Welcome to the Election Page</h1>
    </div>
  )
}

export default Election
